import Vue from 'vue'
import './video-embed.vue'

export default el => new Vue({
  name: 'VideoEmbed',
  el,
})